import { useMutation } from '@tanstack/react-query';
import { searchSamples, type SampleSearchParams, type Sample } from '../services/sampleSearchService';
import { useAuth } from '@/features/auth/';
import { ROLES } from '@/features/auth/constants/roles';

export const useSampleSearch = () => {
  const { user } = useAuth();

  const mutation = useMutation({
    mutationFn: async (params: Omit<SampleSearchParams, 'sampleUserId'>) => {
      if (!user?.id) {
        throw new Error('Usuario no autenticado');
      }

      const searchParams: SampleSearchParams = {
        ...params,
        sampleUserId: [ROLES.ADMIN, ROLES.OBSERVATORIO_EDITOR].includes(user.role as any) ? null : user.id
      };

      return searchSamples(searchParams);
    }
  });

  return {
    searchSamples: mutation.mutate,
    samples: mutation.data,
    isLoading: mutation.isPending,
    error: mutation.error,
    isError: mutation.isError
  };
}; 